import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'actions';

class AllowOpposingTeamsInLineup extends Component {
    onClick(isChecked) {
        this.props.dispatch(Action.set('AllowOpposingTeamsInLineup', isChecked));
    }

    render() {
        const {lineupsFilter} = this.props;
        const isChecked = lineupsFilter.allowOpposingTeamsInLineup;

        return (
            <div>
                <div className="checkbox">
                    <label>
                        <input type="checkbox" checked={isChecked} onChange={(e) => ::this.onClick(e.target.checked)} />
                        Allow opposing teams in the same lineup
                    </label>
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {filters: lineupsFilter} = state.lineupsData;
    return {
        lineupsFilter,
    };
}

export default connect(mapStatesToProps)(AllowOpposingTeamsInLineup);
